var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('aside',{staticClass:"snackbar",class:{ show: _vm.isVisible, [_vm.style]: true }},[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }